import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { APPLICANT_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer, createOperationStateReducer,
} from '../../utils/getCrudConfig';
import {
  EDIT_APPLICANT_BY_ID,
  LOAD_APPLICANT_BY_ID,
  LOAD_APPLICANT_LIST,
} from './actions';

const initialState = {
  applicantList: [],
  applicantListMeta: {},
  loadingApplicantList: false,
  loadingCurrentApplicant: false,
  currentApplicant: {},
  loadingEditApplicant: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(APPLICANT_MODULE + LOAD_APPLICANT_LIST, 'applicantList', 'loadingApplicantList'),
  ...createLoadParameterReducer(APPLICANT_MODULE + LOAD_APPLICANT_BY_ID, 'currentApplicant', 'loadingCurrentApplicant'),
  ...createOperationStateReducer(APPLICANT_MODULE + EDIT_APPLICANT_BY_ID, 'loadingEditApplicant'),
}, initialState);

export default reducer;

export const getApplicantData = createSelector(
  [state => state[APPLICANT_MODULE]],
  state => {
    const {
      applicantList,
      applicantListMeta,
      loadingApplicantList,
      loadingCurrentApplicant,
      loadingEditApplicant,
      currentApplicant,
    } = state;

    return {
      applicantList,
      applicantListMeta,
      loadingApplicantList,
      loadingCurrentApplicant,
      currentApplicant,
      loadingEditApplicant,
    };
  },
);
